import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  InputDate,
} from '@/components/_common';
import { TaxCouponGeneralForm } from '@/core/domain/coupon/coupons/coupons.types';
import { Col, Form, FormInstance, Input, Row } from 'antd';

interface Props {
  form: FormInstance<TaxCouponGeneralForm>;
}

const InfoiceCFeGeneralForm: React.FC<Props> = ({ form }) => {
  return (
    <Form form={form} name="general">
      <Row gutter={[16, 16]}>
        <Col span={24} md={12} lg={6}>
          <FloatingFormItem label="Empresa" name="companyId">
            <CompaniesInfiniteSelectField disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6}>
          <FloatingFormItem label="Chave do cupom" name="sefazReferenceCode">
            <Input disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6}>
          <FloatingFormItem label="Data de criação" name="createdAt">
            <InputDate disabled />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default InfoiceCFeGeneralForm;
